// Search arraay and return length of items that are "selected"
export default function arrHasSelectedItems (array) {
  let arr = array.filter(item => item.selected);
  return arr.length;
};